module.exports = __webpack_public_path__ + "static/media/icon-warning.5ebb17ec.svg";